var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.wrapper},[_c('vue-numeric',{class:_vm.className,attrs:{"empty-value":_vm.emptyValue,"min":_vm.min,"max":_vm.max,"minus":_vm.minus,"precision":_vm.precision,"placeholder":_vm.placeholder,"type":"number"},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }